import { useEffect } from "react";
import { Flex, Text, Select } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getStores } from "../../actions/storesActions";
import { Spinner } from "react-bootstrap";

const MisTiendasDropdown = ({ label, errors, touched, ...props }) => {
  const dispatch = useDispatch();
  const { loading, stores } = useSelector(state => state.storesList)

  useEffect(() => {
    dispatch(getStores());
  }, [dispatch])

  if(loading) return <Spinner color="gray.500" size="xl" />

  return (
    <>
      <Flex justifyContent="space-between" w="100%"
      flexDir={'column'}
      >
        <Text mr="20px" minW="80px">
          {label}
        </Text>
        <Select 
          {...props}
        >
          <option value="">Selecciona una tienda</option>
          {stores?.map((store) => (
            <option key={store._id} value={store._id}>
              {store.name}
            </option>
          ))}
        </Select>
      </Flex>
      <Flex minH="40px" color={"red.500"}>
        {errors && touched && errors}
      </Flex>
    </>
  );
};

export default MisTiendasDropdown;
